import { T } from "@tolgee/react";
import { Button, ButtonProps } from "../ui";
import { FC } from "react";

export const CheckCrpQuantitiesCloseButton: FC<ButtonProps> = (props) => {
  return (
    <Button className="!text-xs" variant="text" color="indigo" {...props}>
      <T keyName="check-crp-quantities-dialog-content-close-button-text" />
    </Button>
  );
};
